<script>
	import Navbar from "./Components/Navbar.svelte";
	import NavbarItem from "./Components/Navbar/NavbarItem.svelte";
	import Section from "./Components/Section.svelte";
	import Hero from "./Components/Hero.svelte";
	import TeamMember from "./Components/TeamMember.svelte";
	import Footer from "./Components/Footer.svelte";
	import ImagePreview from "./Components/ImagePreview.svelte";
	import Timeline from "./Components/Timeline.svelte";
	import TimelineItem from "./Components/Timeline/TimelineItem.svelte";
	import Faq from "./Components/Faq.svelte";
	import FaqItem from "./Components/Faq/FaqItem.svelte";
	import AboutBox from "./Components/AboutBox.svelte";

	import { dinoTypes, teamMembers, socials } from "./lib/stores";

	// props from main.js
	export let title;
	export let subtitle;
</script>

<Navbar>
	<slot slot="icon">
		<figure class="image is-square logo-image">
			<img src="./images/logo.png" />
		</figure>
	</slot>
	<slot slot="items">
		<NavbarItem link="#">Home</NavbarItem>
		<NavbarItem link="#about">About</NavbarItem>
		<NavbarItem link="#dinosols">Dinosols</NavbarItem>
		<NavbarItem link="#roadmap">Roadmap</NavbarItem>
		<NavbarItem link="#team">Team</NavbarItem>
		<NavbarItem link="./arcade">Arcade</NavbarItem>
		{#each socials as social}
			<NavbarItem link={social.link}>
				<i class="fab {social.icon}" />
			</NavbarItem>
		{/each}
	</slot>
</Navbar>

<Hero {title} {subtitle} />

<Section id="about" title="About" classes=" alternate">
	<AboutBox />
</Section>

<Section id="dinosols" classes="is-small alternate">
	<div class="columns is-multiline is-mobile">
		{#each dinoTypes as dino}
			<div class="column is-one-quarter-tablet is-half-mobile">
				<div class="card">
					<div class="card-image">
						<ImagePreview
							imageSrc={dino.imageSrc}
							imageAlt={dino.name}
						/>
					</div>
				</div>
			</div>
		{/each}
	</div>
</Section>

<Section id="roadmap" title="Roadmap" classes="is-small">
	<Timeline>
		<TimelineItem name="Community Building [ongoing]" completed="false">
			Build a community through social media and direct engagement. We
			will utilize Discord and Twitter to communicate with the community.
		</TimelineItem>
		<TimelineItem name="Dinosol Egg Mint [complete]" completed="true">
			Build a community through social media and direct engagement. We
			will utilize Discord and Twitter to communicate with the community.
		</TimelineItem>
		<TimelineItem
			name="Gameplay Internal Testing [complete]"
			completed="true"
		>
			Our team will test gameplay mechanics prior to public use. We plan
			on sharing images, videos, or demos.
		</TimelineItem>
		<TimelineItem name="Gameplay Alpha Testing [ongoing]" completed="false">
			Dinosol Eggs holders and certain community members may opt in to
			test Dinosol Kingdom’s gaming mechanics. The participants will play
			a vital role in providing feedback and refining gameplay prior to
			mint.
		</TimelineItem>
		<TimelineItem name="Minting" completed="false">
			We will mint 4,000 Dinosols. Gameplay will be available immediately
			post mint.
		</TimelineItem>
		<TimelineItem name="Gameplay Beta Testing" completed="false">
			All Dinosol holders may now engage in Dinosol Kingdom gameplay. We
			will continue to improve gameplay mechanics.
		</TimelineItem>
		<TimelineItem name="Seasons and Tournaments" completed="false">
			Dinosol NFT holders can enter into seasons and tournaments that
			reward winners and participants with SOL rewards that come from a %
			of secondary sale royalties.
		</TimelineItem>
		<TimelineItem name="Expansion" completed="false">
			Expand gameplay and community to engage a large audience.
		</TimelineItem>
	</Timeline>
</Section>

<Faq />

<Section id="team" title="Team" classes="is-small">
	<div class="columns is-multiline is-mobile">
		{#each teamMembers as teamMember}
			<div class="column is-one-third-tablet is-full-mobile">
				<TeamMember
					name={teamMember.name}
					title={teamMember.title}
					twitter={teamMember.twitter}
					image={teamMember.image}
				>
					{teamMember.blurb}
				</TeamMember>
			</div>
		{/each}
	</div>
</Section>

<Footer />

<style lang="scss">
</style>
